.buttonsContainer {
    display: flex;
    margin-top: 20px;
    justify-content: flex-end;
    gap: 10px;
}

.question {
    margin-bottom: 20px;
}

.section {
    margin-bottom: 60px;
}

.sectionNameAndCheckboxContainer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: var(--hps-light-gray);
    padding: 20px;
    margin-bottom: 20px;
}

.sectionNameContainer {
    display: flex;
    flex-direction: column;
}

.checkboxContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.disabledIrqAlert {
    display: flex;
    gap: 10px;
}

.sectionsProgress {
    display: flex;
    flex-direction: row;
    gap: 40px;
    margin-bottom: 20px;
}